import VendorCreditCard from "@molecules/ObjectCard/ObjectCards/VendorCreditCard/VendorCreditCard"

import CardsView from "@organisms/ObjectsView/CardsView/CardsView"

export default function VendorCreditCardsView() {
    return (
        <CardsView.List<VendorCredit>>
            {(vendorCredit, displayedAttributes, cardProps) => (
                <VendorCreditCard
                    vendorCredit={vendorCredit}
                    displayedAttributes={displayedAttributes}
                    {...cardProps}
                />
            )}
        </CardsView.List>
    )
}
